"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LayoutGallery = _interopRequireDefault(require("../Layout/LayoutGallery"));

var _GridModule = _interopRequireDefault(require("../Module/GridModule"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ModelsGallery = ({
  mediaWidth = undefined,
  mediaHeight = 180,
  mediaLayout = "cover",
  padding = 0,
  spacing = 1,
  models = [],
  debug = false
}) => {
  return _react.default.createElement(_LayoutGallery.default, {
    padding: padding,
    spacing: spacing,
    debug: debug
  }, models.map((model, index) => {
    let width, height;

    if (model.mediaWidth && model.mediaHeight) {
      width = model.mediaWidth;
      height = model.mediaHeight;
    } else if (model.imageWidth && model.imageHeight) {
      width = model.imageWidth;
      height = model.imageHeight;
    }

    model = _extends({}, model, {
      width: Math.floor(mediaHeight * (width / height)) || mediaHeight,
      mediaHeight: mediaHeight,
      mediaLayout: mediaLayout
    });
    return _react.default.createElement(_GridModule.default, _extends({}, model, {
      width: model.width,
      key: index
    }));
  }));
};

var _default = ModelsGallery;
exports.default = _default;
module.exports = exports.default;